// extracted by mini-css-extract-plugin
module.exports = {"controls":"ForecastCardCarousel_controls__t9kIS"};